export const DOMAIN = 'starsavers.app'
